export const CompassIcon = () => {
    return (
        <svg
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="10.5" cy="10.5" r="9.5" stroke="currentColor" strokeWidth={'2'} />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.7343 5.32861L12.0314 12.0316L5.32837 15.7344L9.03125 9.03142L15.7343 5.32861ZM10.5 12.0001C11.3284 12.0001 12 11.3286 12 10.5001C12 9.67171 11.3284 9.00014 10.5 9.00014C9.67154 9.00014 8.99997 9.67171 8.99997 10.5001C8.99997 11.3286 9.67154 12.0001 10.5 12.0001Z"
                fill="currentColor"
            />
        </svg>
    );
};
